enum ActionTypes {
	request = 'Currency.request',
	receive = 'Currency.receive',
}

export default ActionTypes;
